export const REGEX = {
	NAME: /^[a-zA-Z0-9\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3]+(([a-zA-Z0-9\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3 ])?[a-zA-Z0-9\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3]*)*$/,
	PASSWORD:
		/^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>])(?!.*\s)(?!.*(.)\1{2,})(?!.*(?:012|123|234|345|456|567|678|789|890|987|876|765|654|543|432|321|098|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|[ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾỄỆỉịỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸ|\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3])).{10,}$/i,
	BASIC_FILES: /\.(jpg|jpeg|png|pdf|zip)$/,
	ALLOW_IMAGES: /\.(jpg|jpeg|png|heif|heic)$/,

	ALLOW_UPLOAD_FILES: /\.(pdf|jpg|jpeg|png|heif|heic)$/,
	APPLE_FILES: /\.(heif|heic)$/,
	ALLOW_NUMBER_SPECIAL_CHARS:
		/[^0-9!’@#$%^&*()\-=+×÷=\[\]{};:'",.<>\/?\\|`~₫ ]/g,
	ALLOW_NUMBER: /[^0-9]/g,
	ALLOW_KR_EN_NUMBER_SPECIAL_CHARS:
		/[^a-zA-Z\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\d\s!’@#$%^&*()-_=+×÷=[\]{};:'",.<>/?\\|`~]/g,
	ALLOW_KR_EN_SPECIAL_CHARS:
		/[^a-zA-Z\u3131-\u314e\u314f-\u3163\uac00-\ud7a3\s!’@#$%^&*()_=+×÷=\[\]{};:'",.<>\/?\\|`~-]/g,
	ALLOW_KR_EN: /[^a-zA-Z\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\s]/g,
	ALLOW_KR_EN_NUMBER: /[^a-zA-Z\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\d\s]/g,
	ALLOW_KR: /[^\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3]/g,
	ALLOW_KR_SPACE: /[^\u3131-\u314e\u314f-\u3163\uac00-\ud7a3\s]/g,
	ALLOW_KR_SPECIAL_CHARS:
		/[^\u3131-\u314e\u314f-\u3163\uac00-\ud7a3\s!’@#$%^&*()_=+×÷=\[\]{};:'",.<>\/?\\|`~-]/g,

	ALLOW_NUMBER_DASH: /[^0-9-]/g,
	ONLY_NUMBER: /^[\d]+$/,
	ONLY_NUMBER_DOT: /^[\d.]+$/,
	ONLY_PHONE_NUMBER: /^[0-9()+-]*$/,
	ONLY_NUMBER_DASH: /^[0-9-]*$/,
	ONLY_KR: /^[\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\s]*$/,
	ONLY_EN: /^[a-zA-Z\s]*$/,
	ONLY_EN_KR: /^[a-zA-Z\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\s]*$/,
	ONLY_EN_KR_COMMA_PERIOD:
		/^[a-zA-Z\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\s,·]*$/,
	ONLY_EN_KR_NUMBER: /^[a-zA-Z\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\d\s]*$/,
	ONLY_EN_KR_NUMBER_COMMA_DASH:
		/^[a-zA-Z\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\d\s-—,]*$/,
	ONLY_EN_KR_NUMBER_BRACKET_DASH:
		/^[a-zA-Z\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\d\s()-]*$/,
	ONLY_EN_UPPER_CASE_NUMBER_DASH: /^[A-Z\d-]*$/,
	ALLOW_EN_UPPER_CASE_NUMBER_DASH: /[^A-Z\d-]/g,
	ALLOW_EN_NUMBER_DASH: /[^a-z\d-]/g,
	ONLY_EN_LOWER_CASE_DASH: /^[a-z-]*$/,
	DATE_INPUT_ALLOWED_KEYS_REGEX:
		/^[\d-]$|^(Backspace|Tab|Delete|ArrowLeft|ArrowRight|ArrowUp|ArrowDown)$/,
	// TIME_INPUT_ALLOWED_KEYS_REGEX:
	// 	/^[\d:]$|^(Backspace|Tab|Delete|ArrowLeft|ArrowRight|ArrowUp|ArrowDown)$/,
	DATE_TIME_INPUT_ALLOWED_KEYS_REGEX:
		/^[\d\s-:]$|^(Backspace|Tab|Delete|ArrowLeft|ArrowRight|ArrowUp|ArrowDown)$/,
	TIME_INPUT_ALLOWED_KEYS_REGEX:
		/^[0-9:]$|^(Backspace|Tab|Delete|ArrowLeft|ArrowRight|ArrowUp|ArrowDown)$/,
	ONLY_EN_NUM_SPECIAL: /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]+$/,
	EMAIL:
		/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/,
	ONLY_EN_KR_NUMBER_SPECIAL_CHARS:
		/^[a-zA-Z\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\d\s!’@#$%^&*()-_=+×÷=[\]{};:'",.<>/?\\|`~]*$/,
	ONLY_EN_KR_SPECIAL_CHARS:
		/^[a-zA-Z\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3|!@#$%^&*()_-~`'";:/?<>,.\\|{}[\]\·+=\s]*$/,
	IS_BASE64: /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/,
	ALLOW_PHONE_NUMBER: /[^0-9-]/g,
	ALLOW_WEB_URL:
		/^[a-zA-Z\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\d\s:/?#[\]@!$&'()*+;=\.,]*$/,
	ALLOW_KR_EN_NUMBER_COMMA_PLUS_BRACKET_DASH:
		/^[a-zA-Z\u3131-\u314e\u314f-\u3163\uac00-\ud7a3\d\s()\-+,]*$/,
	IPV4: /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/,
};
